<div class="flex flex-1 justify-between flex-col">
  <div>
    <h1>Panier</h1>
    <mat-accordion *ngIf="commandeLines.length != 0">
      <app-commande-line *ngFor="let commandeLine of commandeLines" [commandeLine]="commandeLine" (deleted)="updateBasket()">
      </app-commande-line>
    </mat-accordion>
    <p *ngIf="commandeLines.length == 0">
      Vous n'avez aucune demande dans votre panier.
    </p>
    <div class="flex flex-row-reverse mt-5">
      <button mat-raised-button color="primary" (click)="valid()"
        [disabled]="commandeLines.length == 0">Valider</button>
    </div>
  </div>
</div>